export default "__VITE_ASSET__BMqbbvWE__"